import type { IOrganizationNodeBasicInfoLegalEntityNodeBasicInfo } from '../types/common';
import type { AuthProviderInfo, SSOOptionInfo } from '../types';
import { AuthProviderType } from '../types';
import { CustomSSOType } from '../types/api/v1/obt/common/auth_config';
import { ssoOptionInfos } from '../constants';

type RegionCode = string;
export type Id = {
  id: string;
};
export type Division = {
  name: string;
  id: Id;
};
export type Divisions = Division[];

export type FormattedEntityOutputObject = {
  regionCode: string;
  divisions: Divisions;
};

export type FormattedEntityOutput = FormattedEntityOutputObject[];

export const getFormattedEntityDetails = (
  entityDetails: IOrganizationNodeBasicInfoLegalEntityNodeBasicInfo[],
): FormattedEntityOutput => {
  const formattedEntityObj: Map<RegionCode, Divisions> = new Map<RegionCode, Divisions>();
  entityDetails.forEach((legalEntity) => {
    const regionCode = legalEntity.legalEntityBasicInfo?.address?.regionCode;
    const name = legalEntity?.legalEntityBasicInfo?.name;
    const id = legalEntity?.legalEntityBasicInfo?.id;
    if (regionCode && name && id) {
      const divisionsData: Divisions = formattedEntityObj.get(regionCode) ?? [];
      divisionsData.push({ name, id });
      formattedEntityObj.set(regionCode, divisionsData);
    }
  });
  const formattedOutput: FormattedEntityOutput = Array.from(formattedEntityObj, ([regionCode, divisions]) => ({
    regionCode,
    divisions,
  }));
  return formattedOutput;
};

export const getSSOButtonInfo = (providerInfo: AuthProviderInfo): SSOOptionInfo => {
  const providerType =
    providerInfo.type === AuthProviderType.CUSTOM
      ? CustomSSOType[providerInfo.ssoType]
      : AuthProviderType[providerInfo.type];

  // Add default values for unknown provider types in case such added in future
  return ssoOptionInfos[providerType] || { label: 'SSO', resourceKey: AuthProviderType.UNRECOGNIZED };
};
